export const medbotVoices = [
    {value: "nova", label: "Nova"},
    {value: "alloy", label: "Alloy"},
    {value: "echo", label: "Echo"},
    {value: "fable", label: "Fable"},
    {value: "onyx", label: "Onyx"},
    {value: "shimmer", label: "Shimmer"}
];